import Vue from 'vue'
import Vuex from 'vuex'
//import { default } from "firebase";
import { School,UserPrivateProfile,UserPublicProfile,CustomClaims,ActionLinkParams} from "@/scripts/datatypes";

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		user: undefined as firebase.default.User | null | undefined,
		claims:undefined as CustomClaims | null | undefined,
    school:undefined as School | null | undefined,
    schoolId: undefined as string | null | undefined,
    userPublicProfile:undefined as UserPublicProfile | null | undefined,
    userPrivateProfile:undefined as UserPrivateProfile | null | undefined,
		lang:undefined as null | undefined,
    isLoading:false as boolean,
    actionLink: undefined as ActionLinkParams | null | undefined,
	},
	mutations: {
		setUser(state, user: firebase.default.User | null) {
			state.user = {...user} as firebase.default.User
		},
		setCustomClaims(state, claims: CustomClaims | undefined) {
			state.claims = (claims) ? {...claims} as CustomClaims : undefined
		},
		setSchool(state, school: School | null) {
			state.school = (school) ? {...school} : null
    },
    setSchoolId(state, schoolId: string | null | undefined) {
			state.schoolId = schoolId
		},
		setUserPublicProfile(state, userPublicProfile: UserPublicProfile | null) {
			state.userPublicProfile = (userPublicProfile) ? {...userPublicProfile} : null
    },
    setUserPrivateProfile(state, userPrivateProfile: UserPrivateProfile | null) {
			state.userPrivateProfile = (userPrivateProfile) ? {...userPrivateProfile} : null
		},
		setLang(state, lang: undefined | null) {
			state.lang = lang
		},
		setLoading(state, isLoading: boolean) {
			state.isLoading = isLoading
    },
    setActionLink(state, actionLink: ActionLinkParams | null) {
			state.actionLink = {...actionLink} as ActionLinkParams
		},
	},
	getters: {
		lang: function(state): string {
			if(state.lang){
				return state.lang
			}
			return ''
		},
		userLang: function(state) {
			if(state.userPrivateProfile && state.userPrivateProfile.lang ){
				return state.userPrivateProfile.lang
			}
			return ''
		},
		uid: function(state) {
			if(state.user && state.user.uid ){
				return state.user.uid
			}
			return ''
    },
    role: function(state,getters): string {
      if(state.schoolId && getters.schools[state.schoolId] && getters.schools[state.schoolId].role){
				return getters.schools[state.schoolId].role
			}
			return ''
		},
    accessLevel: function(state,getters): number {
			if(state.schoolId &&  getters.schools[state.schoolId] && getters.schools[state.schoolId].accessLevel){
				return getters.schools[state.schoolId].accessLevel
			}
			return 0
    },
    displayName: function(state) {
			if(state.userPublicProfile && state.userPublicProfile.displayName ){
				return state.userPublicProfile.displayName
			}
			return ''
    },
    schoolName: function(state) {
			if(state.school && state.school.schoolName ){
				return state.school.schoolName
			}
			return ''
		},
		schoolId: function(state): string {
			if(state.schoolId ){
				return state.schoolId
			}
			return ''
    },
    disabled: function(state,getters){
      if(! state.schoolId || ! getters.schools[state.schoolId] || typeof getters.schools[state.schoolId].disabled !== 'boolean'){
        return null
      }

      if(getters.schools[state.schoolId].disabled === true){
        return true
      }

      return false
    },
    schools: function(state){
      if(state.claims && typeof state.claims.schools === 'object'){
        return state.claims.schools
      }
      return {}
    },
    numSchools: function(state,getters){
      return Object.keys(getters.schools).length
    },
		loading: function(state) {
			return state.isLoading
    },
    actionLinkMode: function(state) {
      if(state.actionLink && state.actionLink.mode){
      return state.actionLink.mode
      }else{
        return ''
      }
    },
    actionLinkCode: function(state) {
      if(state.actionLink && state.actionLink.actionCode){
      return state.actionLink.actionCode
      }else{
        return ''
      }
    },
	},
	actions: {
	},
	modules: {
	}
})
